import {
  Breakdowns,
  Metrics,
  MetricsType,
  AdType,
  AdOutputType,
  Platform,
  TrafficType,
  MaterialType,
  PlaceAdsMetrics,
  MaterialSource,
} from '@pt/enums/insights'
import { t } from '@/lang'
import _ from 'lodash'
import { language } from '@/common/storage'
import { TranslateResult } from 'vue-i18n'

export interface MetricsOption<T = Metrics> {
  label: string
  sceneLabel?: string
  value: T
  description?: TranslateResult
  sceneDescription?: string
  type: MetricsType
  disabled?: boolean
  disabledTooltip?: TranslateResult
}
export type PlaceAdsMetricsOption = MetricsOption<PlaceAdsMetrics>

export interface BreakdownsOptionsModel {
  label: string
  value: Breakdowns
  description?: string
  disabled?: boolean
  disabledTooltip?: TranslateResult
}

// 时间的指标 毫秒
export const timeMetrics: Array<Metrics | PlaceAdsMetrics> = [
  Metrics.fi_time,
  Metrics.ge_time,
  Metrics.stay_time,
]

// 比率的指标
export const rateMetrics: Array<Metrics | PlaceAdsMetrics> = [
  Metrics.fi_rate,
  Metrics.ge_rate,
  Metrics.install_rate,
  Metrics.install_playing_rate,
  Metrics.install_ending_rate,
  Metrics.loss_fi_rate,
  Metrics.loss_after_fi_rate,
  Metrics.loss_playing_rate,
  Metrics.loss_ending_rate,
  Metrics.rp_rate,
  Metrics.go_next_rate,
  Metrics.loss_rate,

  PlaceAdsMetrics.ctr,
  PlaceAdsMetrics.cvr,
  PlaceAdsMetrics.ivr,
]

export const moneyMetrics: Array<Metrics | PlaceAdsMetrics> = [
  PlaceAdsMetrics.cost,
  PlaceAdsMetrics.date_cost,
  PlaceAdsMetrics.cpi,
  PlaceAdsMetrics.cpm,
  PlaceAdsMetrics.cpc,
]

export const placeAdsMetricsOptions: Record<
  PlaceAdsMetrics,
  MetricsOption<PlaceAdsMetrics>
> = {
  [PlaceAdsMetrics.cost]: {
    label: t('playTurbo.dashboard.adsMetrics.cost.label').toString(),
    value: PlaceAdsMetrics.cost,
    type: MetricsType.PlaceAds,
  },
  [PlaceAdsMetrics.click]: {
    label: t('playTurbo.dashboard.adsMetrics.click.label').toString(),
    value: PlaceAdsMetrics.click,
    type: MetricsType.PlaceAds,
  },
  [PlaceAdsMetrics.impression]: {
    label: t('playTurbo.dashboard.adsMetrics.impression.label').toString(),
    value: PlaceAdsMetrics.impression,
    type: MetricsType.PlaceAds,
  },
  [PlaceAdsMetrics.install]: {
    label: t('playTurbo.dashboard.adsMetrics.install.label').toString(),
    value: PlaceAdsMetrics.install,
    type: MetricsType.PlaceAds,
  },
  [PlaceAdsMetrics.ctr]: {
    label: t('playTurbo.dashboard.adsMetrics.ctr.label').toString(),
    description: t('playTurbo.dashboard.adsMetrics.ctr.desc').toString(),
    value: PlaceAdsMetrics.ctr,
    type: MetricsType.PlaceAds,
  },
  [PlaceAdsMetrics.cvr]: {
    label: t('playTurbo.dashboard.adsMetrics.cvr.label').toString(),
    description: t('playTurbo.dashboard.adsMetrics.cvr.desc').toString(),
    value: PlaceAdsMetrics.cvr,
    type: MetricsType.PlaceAds,
  },
  [PlaceAdsMetrics.ivr]: {
    label: t('playTurbo.dashboard.adsMetrics.ivr.label').toString(),
    description: t('playTurbo.dashboard.adsMetrics.ivr.desc').toString(),
    value: PlaceAdsMetrics.ivr,
    type: MetricsType.PlaceAds,
  },
  [PlaceAdsMetrics.cpi]: {
    label: t('playTurbo.dashboard.adsMetrics.cpi.label').toString(),
    description: t('playTurbo.dashboard.adsMetrics.cpi.desc').toString(),
    value: PlaceAdsMetrics.cpi,
    type: MetricsType.PlaceAds,
  },
  [PlaceAdsMetrics.cpm]: {
    label: t('playTurbo.dashboard.adsMetrics.cpm.label').toString(),
    description: t('playTurbo.dashboard.adsMetrics.cpm.desc').toString(),
    value: PlaceAdsMetrics.cpm,
    type: MetricsType.PlaceAds,
  },
  [PlaceAdsMetrics.cpc]: {
    label: t('playTurbo.dashboard.adsMetrics.cpc.label').toString(),
    description: t('playTurbo.dashboard.adsMetrics.cpc.desc').toString(),
    value: PlaceAdsMetrics.cpc,
    type: MetricsType.PlaceAds,
  },

  [PlaceAdsMetrics.date_cost]: {
    label: t('playTurbo.dashboard.adsMetrics.date_cost.label').toString(),
    value: PlaceAdsMetrics.date_cost,
    type: MetricsType.PlaceAds,
  },
  [PlaceAdsMetrics.date_impression]: {
    label: t('playTurbo.dashboard.adsMetrics.date_impression.label').toString(),
    value: PlaceAdsMetrics.date_impression,
    type: MetricsType.PlaceAds,
  },
  [PlaceAdsMetrics.date_click]: {
    label: t('playTurbo.dashboard.adsMetrics.date_click.label').toString(),
    value: PlaceAdsMetrics.date_click,
    type: MetricsType.PlaceAds,
  },
  [PlaceAdsMetrics.date_install]: {
    label: t('playTurbo.dashboard.adsMetrics.date_install.label').toString(),
    value: PlaceAdsMetrics.date_install,
    type: MetricsType.PlaceAds,
  },
}

// 所有指标的数据
export const metricsOptions: Record<Metrics, MetricsOption> = {
  [Metrics.gs]: {
    label: t('playTurbo.dashboard.metrics.gs.label').toString(),
    value: Metrics.gs,
    description: t('playTurbo.dashboard.metrics.gs.desc').toString(),
    type: MetricsType.Action,
  },
  [Metrics.fi]: {
    label: t('playTurbo.dashboard.metrics.fi.label').toString(),
    sceneLabel: t('playTurbo.dashboard.metrics.fi.scene_label').toString(),
    value: Metrics.fi,
    description: t('playTurbo.dashboard.metrics.fi.desc').toString(),
    type: MetricsType.Action,
  },
  [Metrics.ge]: {
    label: t('playTurbo.dashboard.metrics.ge.label').toString(),
    value: Metrics.ge,
    description: t('playTurbo.dashboard.metrics.ge.desc').toString(),
    type: MetricsType.Action,
  },
  [Metrics.vi]: {
    label: t('playTurbo.dashboard.metrics.vi.label').toString(),
    value: Metrics.vi,
    description: t('playTurbo.dashboard.metrics.vi.desc').toString(),
    type: MetricsType.Action,
  },
  [Metrics.vi_avg]: {
    label: t('playTurbo.dashboard.metrics.vi_avg.label').toString(),
    value: Metrics.vi_avg,
    description: t('playTurbo.dashboard.metrics.vi_avg.desc').toString(),
    type: MetricsType.Action,
  },
  [Metrics.wc]: {
    label: t('playTurbo.dashboard.metrics.wc.label').toString(),
    value: Metrics.wc,
    description: t('playTurbo.dashboard.metrics.wc.desc').toString(),
    type: MetricsType.Action,
  },
  [Metrics.install]: {
    label: t('playTurbo.dashboard.metrics.install.label').toString(),
    sceneLabel: t('playTurbo.dashboard.metrics.install.scene_label').toString(),
    value: Metrics.install,
    description: t('playTurbo.dashboard.metrics.install.desc').toString(),
    type: MetricsType.Translate,
  },
  [Metrics.replay]: {
    label: t('playTurbo.dashboard.metrics.replay.label').toString(),
    value: Metrics.replay,
    description: t('playTurbo.dashboard.metrics.replay.desc').toString(),
    type: MetricsType.Action,
  },
  [Metrics.fi_time]: {
    label: t('playTurbo.dashboard.metrics.fi_time.label').toString(),
    value: Metrics.fi_time,
    description: t('playTurbo.dashboard.metrics.fi_time.desc').toString(),
    type: MetricsType.Action,
  },
  [Metrics.ge_auto]: {
    label: t('playTurbo.dashboard.metrics.ge_auto.label').toString(),
    value: Metrics.ge_auto,
    description: t('playTurbo.dashboard.metrics.ge_auto.desc').toString(),
    type: MetricsType.Action,
  },
  [Metrics.ge_manual]: {
    label: t('playTurbo.dashboard.metrics.ge_manual.label').toString(),
    value: Metrics.ge_manual,
    description: t('playTurbo.dashboard.metrics.ge_manual.desc').toString(),
    type: MetricsType.Action,
  },
  [Metrics.ge_time]: {
    label: t('playTurbo.dashboard.metrics.ge_time.label').toString(),
    value: Metrics.ge_time,
    description: t('playTurbo.dashboard.metrics.ge_time.desc').toString(),
    type: MetricsType.Action,
  },
  [Metrics.loss]: {
    label: t('playTurbo.dashboard.metrics.loss.label').toString(),
    value: Metrics.loss,
    description: t('playTurbo.dashboard.metrics.loss.desc').toString(),
    type: MetricsType.Loss,
  },
  [Metrics.loss_fi]: {
    label: t('playTurbo.dashboard.metrics.loss_fi.label').toString(),
    sceneLabel: t('playTurbo.dashboard.metrics.loss_fi.scene_label').toString(),
    value: Metrics.loss_fi,
    description: t('playTurbo.dashboard.metrics.loss_fi.desc').toString(),
    type: MetricsType.Loss,
  },
  [Metrics.loss_after_fi]: {
    label: t('playTurbo.dashboard.metrics.loss_after_fi.label').toString(),
    sceneLabel: t(
      'playTurbo.dashboard.metrics.loss_after_fi.scene_label',
    ).toString(),
    value: Metrics.loss_after_fi,
    description: t('playTurbo.dashboard.metrics.loss_after_fi.desc').toString(),
    type: MetricsType.Loss,
  },
  [Metrics.loss_playing]: {
    label: t('playTurbo.dashboard.metrics.loss_playing.label').toString(),
    value: Metrics.loss_playing,
    description: t('playTurbo.dashboard.metrics.loss_playing.desc').toString(),
    type: MetricsType.Loss,
  },
  [Metrics.loss_ending]: {
    label: t('playTurbo.dashboard.metrics.loss_ending.label').toString(),
    value: Metrics.loss_ending,
    description: t('playTurbo.dashboard.metrics.loss_ending.desc').toString(),
    type: MetricsType.Loss,
  },
  [Metrics.loss_rate]: {
    label: t('playTurbo.dashboard.metrics.loss_rate.label').toString(),
    value: Metrics.loss_rate,
    description: t('playTurbo.dashboard.metrics.loss_rate.desc').toString(),
    type: MetricsType.Loss,
  },
  [Metrics.loss_fi_rate]: {
    label: t('playTurbo.dashboard.metrics.loss_fi_rate.label').toString(),
    sceneLabel: t(
      'playTurbo.dashboard.metrics.loss_fi_rate.scene_label',
    ).toString(),
    value: Metrics.loss_fi_rate,
    description: t('playTurbo.dashboard.metrics.loss_fi_rate.desc').toString(),
    sceneDescription: t(
      'playTurbo.dashboard.metrics.loss_fi_rate.scene_desc',
    ).toString(),
    type: MetricsType.Loss,
  },
  [Metrics.loss_after_fi_rate]: {
    label: t('playTurbo.dashboard.metrics.loss_after_fi_rate.label').toString(),
    sceneLabel: t(
      'playTurbo.dashboard.metrics.loss_after_fi_rate.scene_label',
    ).toString(),
    value: Metrics.loss_after_fi_rate,
    description: t(
      'playTurbo.dashboard.metrics.loss_after_fi_rate.desc',
    ).toString(),
    sceneDescription: t(
      'playTurbo.dashboard.metrics.loss_after_fi_rate.scene_desc',
    ).toString(),
    type: MetricsType.Loss,
  },
  [Metrics.loss_playing_rate]: {
    label: t('playTurbo.dashboard.metrics.loss_playing_rate.label').toString(),
    value: Metrics.loss_playing_rate,
    description: t(
      'playTurbo.dashboard.metrics.loss_playing_rate.desc',
    ).toString(),
    type: MetricsType.Loss,
  },
  [Metrics.loss_ending_rate]: {
    label: t('playTurbo.dashboard.metrics.loss_ending_rate.label').toString(),
    value: Metrics.loss_ending_rate,
    description: t(
      'playTurbo.dashboard.metrics.loss_ending_rate.desc',
    ).toString(),
    type: MetricsType.Loss,
  },
  [Metrics.install_auto]: {
    label: t('playTurbo.dashboard.metrics.install_auto.label').toString(),
    value: Metrics.install_auto,
    description: t('playTurbo.dashboard.metrics.install_auto.desc').toString(),
    type: MetricsType.Translate,
  },
  [Metrics.install_manual]: {
    label: t('playTurbo.dashboard.metrics.install_manual.label').toString(),
    value: Metrics.install_manual,
    description: t(
      'playTurbo.dashboard.metrics.install_manual.desc',
    ).toString(),
    type: MetricsType.Translate,
  },
  [Metrics.install_rate]: {
    label: t('playTurbo.dashboard.metrics.install_rate.label').toString(),
    sceneLabel: t(
      'playTurbo.dashboard.metrics.install_rate.scene_label',
    ).toString(),
    value: Metrics.install_rate,
    description: t('playTurbo.dashboard.metrics.install_rate.desc').toString(),
    sceneDescription: t(
      'playTurbo.dashboard.metrics.install_rate.scene_desc',
    ).toString(),
    type: MetricsType.Translate,
  },
  [Metrics.install_playing_rate]: {
    label: t(
      'playTurbo.dashboard.metrics.install_playing_rate.label',
    ).toString(),
    value: Metrics.install_playing_rate,
    description: t(
      'playTurbo.dashboard.metrics.install_playing_rate.desc',
    ).toString(),
    type: MetricsType.Translate,
  },
  [Metrics.install_ending_rate]: {
    label: t(
      'playTurbo.dashboard.metrics.install_ending_rate.label',
    ).toString(),
    value: Metrics.install_ending_rate,
    description: t(
      'playTurbo.dashboard.metrics.install_ending_rate.desc',
    ).toString(),
    type: MetricsType.Translate,
  },
  [Metrics.fi_rate]: {
    label: t('playTurbo.dashboard.metrics.fi_rate.label').toString(),
    sceneLabel: t('playTurbo.dashboard.metrics.fi_rate.scene_label').toString(),
    value: Metrics.fi_rate,
    description: t('playTurbo.dashboard.metrics.fi_rate.desc').toString(),
    sceneDescription: t(
      'playTurbo.dashboard.metrics.fi_rate.scene_desc',
    ).toString(),
    type: MetricsType.Action,
  },
  [Metrics.ge_rate]: {
    label: t('playTurbo.dashboard.metrics.ge_rate.label').toString(),
    value: Metrics.ge_rate,
    description: t('playTurbo.dashboard.metrics.ge_rate.desc').toString(),
    type: MetricsType.Action,
  },
  [Metrics.rp_rate]: {
    label: t('playTurbo.dashboard.metrics.rp_rate.label').toString(),
    value: Metrics.rp_rate,
    description: t('playTurbo.dashboard.metrics.rp_rate.desc').toString(),
    type: MetricsType.Action,
  },

  [Metrics.reach]: {
    label: t('playTurbo.dashboard.metrics.reach.label').toString(),
    value: Metrics.reach,
    description: t('playTurbo.dashboard.metrics.reach.desc').toString(),
    type: MetricsType.Action,
  },
  [Metrics.go_next]: {
    label: t('playTurbo.dashboard.metrics.go_next.label').toString(),
    value: Metrics.go_next,
    description: t('playTurbo.dashboard.metrics.go_next.desc').toString(),
    type: MetricsType.Action,
  },
  [Metrics.go_next_rate]: {
    label: t('playTurbo.dashboard.metrics.go_next_rate.label').toString(),
    value: Metrics.go_next_rate,
    description: t('playTurbo.dashboard.metrics.go_next_rate.desc').toString(),
    type: MetricsType.Action,
  },
  [Metrics.stay_time]: {
    label: t('playTurbo.dashboard.metrics.stay_time.label').toString(),
    value: Metrics.stay_time,
    description: t('playTurbo.dashboard.metrics.stay_time.desc').toString(),
    type: MetricsType.Action,
  },
  [Metrics.install_playing]: {
    label: t('playTurbo.dashboard.metrics.install_playing.label').toString(),
    value: Metrics.install_playing,
    description: t(
      'playTurbo.dashboard.metrics.install_playing.desc',
    ).toString(),
    type: MetricsType.Translate,
  },
  [Metrics.install_ending]: {
    label: t('playTurbo.dashboard.metrics.install_ending.label').toString(),
    value: Metrics.install_ending,
    description: t(
      'playTurbo.dashboard.metrics.install_ending.desc',
    ).toString(),
    type: MetricsType.Translate,
  },
  [Metrics.action1]: {
    label: 'action1',
    value: Metrics.action1,
    type: MetricsType.Custom,
  },
  [Metrics.action2]: {
    label: 'action2',
    value: Metrics.action2,
    type: MetricsType.Custom,
  },
  [Metrics.action3]: {
    label: 'action3',
    value: Metrics.action3,
    type: MetricsType.Custom,
  },
  [Metrics.action4]: {
    label: 'action4',
    value: Metrics.action4,
    type: MetricsType.Custom,
  },
  [Metrics.action5]: {
    label: 'action5',
    value: Metrics.action5,
    type: MetricsType.Custom,
  },
  [Metrics.action6]: {
    label: 'action6',
    value: Metrics.action6,
    type: MetricsType.Custom,
  },
  [Metrics.action7]: {
    label: 'action7',
    value: Metrics.action7,
    type: MetricsType.Custom,
  },
  [Metrics.action8]: {
    label: 'action8',
    value: Metrics.action8,
    type: MetricsType.Custom,
  },
  [Metrics.action9]: {
    label: 'action9',
    value: Metrics.action9,
    type: MetricsType.Custom,
  },
  [Metrics.action10]: {
    label: 'action10',
    value: Metrics.action10,
    type: MetricsType.Custom,
  },
}

// 素材分析所有指标的分类数据
export const metricsTypeOptions = [
  {
    label: t('playTurbo.dashboard.metricsType.action').toString(),
    value: MetricsType.Action,
    children: _.filter(metricsOptions, (t) => t.type === MetricsType.Action),
  },
  {
    label: t('playTurbo.dashboard.metricsType.translate').toString(),
    value: MetricsType.Translate,
    children: _.filter(metricsOptions, (t) => t.type === MetricsType.Translate),
  },
  {
    label: t('playTurbo.dashboard.metricsType.loss').toString(),
    value: MetricsType.Loss,
    children: _.filter(metricsOptions, (t) => t.type === MetricsType.Loss),
  },
]

/**
 * 试玩分析页面适用的指标配置
 */
// 投放指标
export const placeAdsMetrics: PlaceAdsMetrics[] = Object.values(
  placeAdsMetricsOptions,
).map((item) => item.value)

// 交互指标
export const plMetrics: Metrics[] = [
  Metrics.fi_rate,
  Metrics.ge_rate,
  Metrics.vi_avg,
  Metrics.rp_rate,
  Metrics.fi_time,
  Metrics.ge_time,
  // Metrics.gs,
  // Metrics.fi,
  // Metrics.ge,
  // Metrics.vi,
  // Metrics.wc,
  // Metrics.install,
  // Metrics.install_auto,
  // Metrics.install_manual,
  // Metrics.install_playing,
  // Metrics.install_ending,
  Metrics.install_rate,
  Metrics.install_playing_rate,
  Metrics.install_ending_rate,
  // Metrics.ge_auto,
  // Metrics.ge_manual,
  // Metrics.replay,
  // Metrics.loss_fi,
  // Metrics.loss_after_fi,
  // Metrics.loss_playing,
  // Metrics.loss_ending,
  Metrics.loss_fi_rate,
  Metrics.loss_after_fi_rate,
  Metrics.loss_playing_rate,
  Metrics.loss_ending_rate,
]
/** **************************************************/

export const BreakdownsOptions: BreakdownsOptionsModel[] = [
  {
    label: t('playTurbo.dashboard.breakdowns.period').toString(),
    value: Breakdowns.period,
  },
  {
    label: t('playTurbo.dashboard.breakdowns.traffic_type').toString(),
    value: Breakdowns.traffic_type,
  },
  {
    label: t('playTurbo.dashboard.breakdowns.platform').toString(),
    value: Breakdowns.platform,
  },
  {
    label: t('playTurbo.dashboard.breakdowns.country_code').toString(),
    value: Breakdowns.country_code,
  },
  {
    label: t('playTurbo.dashboard.breakdowns.project_id').toString(),
    value: Breakdowns.project_id,
  },

  {
    label: t('playTurbo.dashboard.breakdowns.ad_type').toString(),
    value: Breakdowns.ad_type,
  },

  {
    label: t('playTurbo.dashboard.breakdowns.ad_output_type').toString(),
    value: Breakdowns.ad_output_type,
  },

  {
    label: t('playTurbo.dashboard.breakdowns.material_name').toString(),
    value: Breakdowns.material_name,
  },
  {
    label: t('playTurbo.dashboard.breakdowns.material_type').toString(),
    value: Breakdowns.material_type,
  },

  {
    label: t('playTurbo.dashboard.breakdowns.mid').toString(),
    value: Breakdowns.mid,
  },
  {
    label: t('playTurbo.dashboard.breakdowns.product_id').toString(),
    value: Breakdowns.product_id,
  },
  {
    label: t('playTurbo.dashboard.breakdowns.basic_id').toString(),
    value: Breakdowns.basic_id,
  },
  {
    label: t('playTurbo.dashboard.breakdowns.package_name').toString(),
    value: Breakdowns.package_name,
  },
  {
    label: t('playTurbo.dashboard.breakdowns.publish_time').toString(),
    value: Breakdowns.publish_time,
  },
  {
    label: t('playTurbo.dashboard.breakdowns.scene').toString(),
    value: Breakdowns.scene,
  },
  {
    label: t('playTurbo.dashboard.breakdowns.material_source').toString(),
    value: Breakdowns.material_source,
  },
  {
    label: t('playTurbo.dashboard.breakdowns.template_id').toString(),
    value: Breakdowns.template_id,
  },

  {
    label: t('playTurbo.dashboard.breakdowns.campaign_id').toString(),
    value: Breakdowns.campaign_id,
  },
  {
    label: t('playTurbo.dashboard.breakdowns.adset_id').toString(),
    value: Breakdowns.adset_id,
  },
  {
    label: t('playTurbo.dashboard.breakdowns.ad_id').toString(),
    value: Breakdowns.ad_id,
  },
  {
    label: t('playTurbo.dashboard.breakdowns.fingerprint').toString(),
    value: Breakdowns.fingerprint,
    description: t(
      'playTurbo.dashboard.breakdowns.fingerprint_desc',
    ).toString(),
  },
]

// 默认时区
export const DEFAULT_TIMEZONE = language.get() === 'en' ? '0' : '8'

export const adTypeOptions = [
  {
    label: t('playTurbo.dashboard.filter.adType.rewardedVideo'),
    value: AdType.RewardedVideo,
  },
  {
    label: t('playTurbo.dashboard.filter.adType.interstitialVideo'),
    value: AdType.InterstitialVideo,
  },
]

export const adOutputTypeOptions = [
  {
    label: t('playTurbo.dashboard.filter.adOutputType.other'),
    value: AdOutputType.Other,
  },
  {
    label: t('playTurbo.dashboard.filter.adOutputType.videoAndCommonEndcard'),
    value: AdOutputType.VideoAndCommonEndcard,
  },
  {
    label: t('playTurbo.dashboard.filter.adOutputType.videoAndDynamicEndcard'),
    value: AdOutputType.VideoAndDynamicEndcard,
  },
  {
    label: t('playTurbo.dashboard.filter.adOutputType.videoAndPlayable'),
    value: AdOutputType.VideoAndPlayable,
  },
  {
    label: t('playTurbo.dashboard.filter.adOutputType.onlyVideo'),
    value: AdOutputType.OnlyVideo,
  },
  {
    label: t('playTurbo.dashboard.filter.adOutputType.onlyPlayable'),
    value: AdOutputType.OnlyPlayable,
  },
]

export const platformOptions = [
  {
    label: t('playTurbo.dashboard.filter.platform.ios'),
    value: Platform.IOS,
  },
  {
    label: t('playTurbo.dashboard.filter.platform.android'),
    value: Platform.Android,
  },
]

// 总览和可玩素材分析的可展示数据的渠道
export const showTrafficType: TrafficType[] = [
  TrafficType.Mintegral,
  TrafficType.Unity,
  TrafficType.Applovin,
]

// 仅有交互指标的渠道
export const allowedOnlyActionTrafficTypes: TrafficType[] = [
  TrafficType.IronSource,
  // TrafficType.Applovin,
  // TrafficType.Vungle,
  TrafficType.Chartboost,
  TrafficType.Moloco,
]

export const allowedDisplayTrafficTypes: TrafficType[] = [
  TrafficType.Mintegral,
  TrafficType.Unity,
  TrafficType.Applovin,
  ...allowedOnlyActionTrafficTypes,
]

export const materialTypeOptions = [
  {
    label: t('playTurbo.dashboard.filter.materialType.pl'),
    value: MaterialType.PL,
  },
  {
    label: t('playTurbo.dashboard.filter.materialType.video'),
    value: MaterialType.Video,
  },
  {
    label: t('playTurbo.dashboard.filter.materialType.graphic'),
    value: MaterialType.Graphic,
  },
  // {
  //   label: t('playTurbo.dashboard.filter.materialType.unknown'),
  //   value: MaterialType.Unknown,
  // },
]

// 素材来源
export const materialSourceOptions = [
  // {
  // label: t('playTurbo.dashboard.filter.materialSource.unknown'),
  //   value: MaterialSource.Unknown,
  // },
  {
    label: t('playTurbo.dashboard.filter.materialSource.playturboTemplate'),
    value: MaterialSource.PlayturboTemplate,
  },
  {
    label: t('playTurbo.dashboard.filter.materialSource.playsmart'),
    value: MaterialSource.Playsmart,
  },
  {
    label: t('playTurbo.dashboard.filter.materialSource.mws'),
    value: MaterialSource.MWS,
  },
  {
    label: t('playTurbo.dashboard.filter.materialSource.adPlatform'),
    value: MaterialSource.AdPlatform,
  },
]

// TODO 待优化：因为投放数据是支持的
// 对于渠道非Mintegral的素材，在「素材分析」详情页（即场景分析）禁用「投放地区」和「广告类型」的筛选和维度
export const disabledBreakdowns = [Breakdowns.country_code, Breakdowns.ad_type]
